import {h, Fragment} from "preact"
export default function MobileSearchToggle({ searchOpen, toggleSearch }) {
    return (
      <div
        class="mobile-collection-search mobile-only"
        style={{ cursor: "pointer" }}
        role="button"
        tabIndex={0}
        aria-label="Toggle Search Bar"
        onClick={toggleSearch}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') toggleSearch(); }}
      >
        <svg
          viewBox="0 0 19 21"
          fill="currentColor"
          width="24"
          height="24"
          aria-hidden="true"
          focusable="false"
        >
          <g transform="translate(0,0.472222)">
            <path d="M14.3977778,14.0103889 L19,19.0422222 L17.8135556,20.0555556 L13.224,15.0385 C11.8019062,16.0671405 10.0908414,16.619514 8.33572222,16.6165556 C3.73244444,16.6165556 0,12.8967778 0,8.30722222 C0,3.71766667 3.73244444,0 8.33572222,0 C12.939,0 16.6714444,3.71977778 16.6714444,8.30722222 C16.6739657,10.4296993 15.859848,12.4717967 14.3977778,14.0103889 Z M8.33572222,15.0585556 C12.0766111,15.0585556 15.1081667,12.0365 15.1081667,8.30827778 C15.1081667,4.58005556 12.0766111,1.558 8.33572222,1.558 C4.59483333,1.558 1.56327778,4.58005556 1.56327778,8.30827778 C1.56327778,12.0365 4.59483333,15.0585556 8.33572222,15.0585556 Z" />
          </g>
        </svg>
      </div>
    );
  }